import { Breadcrumbs, Grid, IconButton, Link, Switch, Tooltip, Typography } from "@material-ui/core";
import { Brightness2, Brightness7, Restore, Save } from "@material-ui/icons";
import { FC } from "react";
import ChevronRight from "src/icons/ChevronRight";

type TopBarProps = {
  isDarkMode: boolean;
  isChanged: boolean;
  handleDarkModeChange: () => void;
  handleRevert: () => void;
  handleSave: () => void;
};

const TopBar: FC<TopBarProps> = ({
  isDarkMode,
  handleDarkModeChange,
  isChanged,
  handleRevert,
  handleSave
}) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center" px={3} py={1}>
      <Grid item>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<ChevronRight fontSize="small" />}
        >
          <Link
            color="textPrimary"
            variant="h5"
          >
            Mobile Configuration
          </Link>
          <Typography color="textPrimary" variant="h5">
            Theme
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item display="flex" alignItems="center" gap={1}>
        <Brightness7 fontSize="small" />
        <Switch
          checked={isDarkMode}
          onChange={handleDarkModeChange}
          color="default"
        />
        <Brightness2 fontSize="small" />
        {isChanged && (
          <Tooltip title="Revert Changes">
            <IconButton size="small" onClick={handleRevert}>
              <Restore />
            </IconButton>
          </Tooltip>
        )}
        {isChanged && (
          <Tooltip title="Save Changes">
            <IconButton size="small" onClick={handleSave}>
              <Save />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
};

export default TopBar;
